import React from 'react'

export default class LayoutPicker extends React.Component {
  prettify(symbol) {
    const [a, b] = symbol.split('_')
    return b + a
  }

  render() {
    return (
      <div className='absolute coin-picker z-index-100 shadow-2'>
        <div className='w10'>
          <button className='bg-animate' onClick={this.props.onCancel}>Back</button>
        </div>
        <div className='w8 pa2'>
          Choose which chart to plot <b>{this.prettify(this.props.symbol)}</b> in.
        </div>
        <div className='fl w-100 pa1'>
          <div className='fl w-50 pa1 layout-box tc'>
            <a href="#charts"
              onClick={() => this.props.onSelect(1)}
              className="f2 no-underline bg-animate inline-flex items-center pa5 ba border-box">
              1
            </a>
          </div>
          <div className='fl w-50 pa1 layout-box'>
            <a href="#charts"
              onClick={() => this.props.onSelect(2)}
              className="f2 no-underline bg-animate inline-flex items-center pa5 ba border-box">
              2
            </a>
          </div>
        </div>
        <div className='fl w-100 pa1'>
          <div className='fl w-50 pa1 layout-box tc'>
            <a href="#charts"
              onClick={() => this.props.onSelect(3)}
              className="f2 no-underline bg-animate inline-flex items-center pa5 ba border-box">
              3
            </a>
          </div>
          <div className='fl w-50 pa1 layout-box'>
            <a href="#charts"
              onClick={() => this.props.onSelect(4)}
              className="f2 no-underline bg-animate inline-flex items-center pa5 ba border-box">
              4
            </a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LayoutPicker.js